import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroDeliveryDetailsSection', {
    addressPlaceholder: 'Enter the address',
    addressTitle: 'Address',
    attentionPlaceholder: 'Enter a person',
    attentionTitle: 'Attention',
    deliveryAddressHeader: 'Delivery address',
    deliveryInstructionsPlaceholder: 'Enter the delivery instructions',
    deliveryInstructionsTitle: 'Delivery instructions',
    phonePlaceholder: 'Enter the phone number',
    phoneTitle: 'Phone',
    searchFromContactsButton: '+ Search from Contacts',
});
